var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhonesvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.75,
    width: 37.5,
    height: 37.5,
    rx: 18.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.75,
    width: 37.5,
    height: 37.5,
    rx: 18.75,
    stroke: "#979797",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9981 22.5152C23.3848 21.9131 22.6192 21.9131 22.0098 22.5152C21.545 22.9736 21.0801 23.4319 20.6231 23.898C20.4981 24.0262 20.3926 24.0534 20.2403 23.9679C19.9395 23.8048 19.6192 23.6727 19.3301 23.4941C17.9824 22.6512 16.8535 21.5674 15.8535 20.3477C15.3574 19.7418 14.916 19.0931 14.6074 18.3628C14.5449 18.2152 14.5566 18.1181 14.6777 17.9977C15.1426 17.551 15.5957 17.0926 16.0527 16.6343C16.6895 15.9973 16.6895 15.2515 16.0488 14.6105C15.6855 14.2454 15.3223 13.8881 14.959 13.5229C14.584 13.15 14.2129 12.7732 13.834 12.4042C13.2207 11.8099 12.455 11.8099 11.8457 12.4081C11.3769 12.8665 10.9277 13.3365 10.4511 13.7871C10.0097 14.2027 9.78704 14.7115 9.74017 15.3058C9.66595 16.2731 9.90423 17.1859 10.2402 18.0754C10.9277 19.9166 11.9746 21.5519 13.2441 23.0512C14.959 25.0789 17.0059 26.6831 19.4004 27.8406C20.4786 28.3612 21.5958 28.7612 22.8106 28.8273C23.6466 28.8739 24.3731 28.6641 24.9552 28.0154C25.3536 27.5726 25.8028 27.1687 26.2247 26.7453C26.8497 26.116 26.8536 25.3547 26.2325 24.7332C25.4903 23.9913 24.7442 23.2532 23.9981 22.5152Z",
    fill: "#004B6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 19.42L24.6915 19.1753C24.4649 17.8585 23.8399 16.666 22.8907 15.7183C21.8867 14.72 20.6172 14.0907 19.2188 13.8965L19.0156 15.3376C20.0977 15.4891 21.0821 15.9746 21.8594 16.7476C22.5938 17.4779 23.0743 18.4023 23.25 19.42Z",
    fill: "#004B6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5079 13.189C23.8438 11.5343 21.7383 10.4894 19.4141 10.167L19.2109 11.6081C21.2188 11.8878 23.0391 12.7928 24.4766 14.2184C25.8399 15.574 26.7345 17.287 27.0587 19.1709L28.5001 18.9262C28.1212 16.7432 27.086 14.7622 25.5079 13.189Z",
    fill: "#004B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonesvg);
export default __webpack_public_path__ + "static/media/PHONESVG.d75e47f6c8b59ae02e2f1cb21bc8d77b.svg";
export { ForwardRef as ReactComponent };